import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { faCog, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../context/AppContext';
import AppSidebar from './AppSidebar';
import { ReactComponent as SidebarHomeIcon } from '../assets/icons/sidebar/ico_sidebar_home.svg';
import { ReactComponent as SidebarResearchIcon } from '../assets/icons/sidebar/ico_sidebar_research.svg';

const CommonSidebar = ({ isCollapsed, onToggleCollapse, hideToggleButton = false }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logoutUser } = useAppContext();

  const isActive = (path) => {
    if (path === '/workspace') {
      return location.pathname === '/workspace';
    }

    if (path === '/projects') {
      return (
        location.pathname.startsWith('/projects') ||
        location.pathname.startsWith('/project/') ||
        location.pathname.startsWith('/study/')
      );
    }

    return false;
  };

  const navItems = [
    {
      path: '/workspace',
      label: 'Home',
      key: 'home',
      sidebarIcon: SidebarHomeIcon,
      active: isActive('/workspace'),
    },
    {
      path: '/projects',
      label: 'Workspace',
      key: 'workspace',
      sidebarIcon: SidebarResearchIcon,
      active: isActive('/projects'),
    },
  ];

  const handleLogout = () => {
    logoutUser();
    navigate('/login');
  };

  return (
    <AppSidebar
      variant="default"
      isCollapsed={isCollapsed}
      onToggleCollapse={onToggleCollapse}
      hideToggleButton={hideToggleButton}
      navItems={navItems}
      userName={user?.name || '사용자'}
      userEmail={user?.email || 'user@example.com'}
      profileMenuItems={[
        {
          key: 'settings',
          label: 'Setting',
          icon: faCog,
          onClick: () => navigate('/settings'),
        },
        {
          key: 'logout',
          label: 'Logout',
          icon: faSignOutAlt,
          danger: true,
          onClick: handleLogout,
        },
      ]}
    />
  );
};

export default CommonSidebar;
